import React from 'react';
import { CtaButton } from './CtaButton';
import { TopoLines } from './TopoLines';
import { ProductStack } from './ProductStack';
const chips = ['6 Volumes', '159 Split-and-Prove Cards', '40 Worksheets', '5 Bonuses', '300 Pages'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Organized by fault, not by brand'];

// Bandas de color de los 6 tomos
const volumes = ['bg-vol-1', 'bg-vol-2', 'bg-vol-3', 'bg-vol-4', 'bg-vol-5', 'bg-vol-6'];
export function Hero() {
  return <section className="topo-dark relative w-full overflow-hidden border-b-4 border-ember bg-forest-deep" data-id="element-119" data-mp="xaxg3qpxbumn">
      <TopoLines className="pointer-events-none absolute -right-24 -top-12 h-[360px] w-[360px] text-paper/[0.07] sm:h-[460px] sm:w-[460px]" data-id="element-120" data-mp="s9gfzxf9kc74" />

      <div className="relative z-10 mx-auto max-w-6xl px-5 pb-14 pt-7 sm:pb-20 sm:pt-12" data-id="element-121" data-mp="3d1a99mbhsfec">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-122" data-mp="382ffjpbzl6fg">
          <div data-id="element-123" data-mp="384s5oprwen3l">
            <p className="eyebrow text-ember" data-id="element-124" data-mp="3j8sezzr63hpb">
              For solar PV technicians, installers &amp; O&amp;M crews
            </p>
            <h1 className="mt-3 font-display text-[40px] leading-[1.02] text-paper sm:text-6xl md:text-7xl" data-id="element-125" data-mp="3o6kd5bieo01y">
              It&apos;s not always the inverter.{' '}
              <span className="text-ember" data-id="element-126" data-mp="3e961rqbca1gi">Prove it before you replace anything.</span>
            </h1>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-paper/80 sm:text-lg" data-id="element-127" data-mp="30iawsp3yo4i7">
              Solar PV &amp; Battery Diagnostic Pro gives you 159 field cards for
              grid-tied, off-grid and hybrid systems — symptom flowcharts,
              inverter and BMS code families, Voc, current, insulation, IV-curve
              and thermal checks with expected readings, code columns for four
              countries, and the reports, estimates and warranty claims that
              close the call.{' '}
              <span className="font-semibold text-paper" data-id="element-128" data-mp="2ljpaivzggqlv">
                Split the system, prove the fault, then fix it — on the first
                truck roll.
              </span>
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-129" data-mp="naa0oqsklilz">
              {chips.map(chip => <li key={chip} className="rounded-md border border-paper/25 bg-paper/10 px-3 py-1.5 font-mono text-[11px] font-bold uppercase tracking-wide text-paper/90" data-id="element-130" data-mp="ibgjana5x7gj">
                  {chip}
                </li>)}
            </ul>
          </div>

          <ProductStack data-id="element-131" data-mp="16342sk53hg8s" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-132" data-mp="112pwb6j56ecv">
          <div className="w-full max-w-md" data-id="element-133" data-mp="11151dfsx0teh">
            <CtaButton data-id="element-134" data-mp="x14nbw9qak7y">Get Solar PV &amp; Battery Diagnostic Pro</CtaButton>
          </div>

          <div className="mt-5 flex max-w-md flex-col items-center gap-2.5 text-center sm:flex-row sm:text-left" data-id="element-135" data-mp="x3h62bnb8ym2">
            <ul className="flex -space-x-1.5" aria-hidden="true" data-id="element-136" data-mp="3hrlk4hb3w58g">
              {volumes.map(color => <li key={color} className={`h-7 w-7 rounded-full border-2 border-forest-deep ${color}`} data-id="element-137" data-mp="1x9ulmd6nbhoh" />)}
            </ul>
            <p className="text-[13px] leading-snug text-paper/70" data-id="element-138" data-mp="26a999j7318v5">
              Built for the techs who service string, micro, optimizer and
              battery systems — with code columns for the US, UK, Canada and
              Australia.
            </p>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-139" data-mp="2g257qvd2z0zw">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-140" data-mp="2p08u1tvw41sr">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-141" data-mp="2tzlgidiun6ut" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}